import { initializeApp } from 'firebase/app';
import { initializeAuth, indexedDBLocalPersistence, browserLocalPersistence } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { pickFirebaseEnv } from '../lib/firebaseEnv.js';

const configs = {
  staging: {
    apiKey: 'AIzaSyDksiKDGzr57-sbwyZqratzcld0qdywqaY',
    // authDomain is the host Firebase Auth uses for its iframe handler
    // (OAuth popups, action-code redirects, etc.). Pointing it at the
    // custom domain keeps users on mytrainforge.com instead of bouncing
    // through gearbox-staging.firebaseapp.com mid-flow. Requires the
    // domain to be in Firebase Console → Auth → Authorized domains.
    authDomain: 'mytrainforge.com',
    projectId: 'gearbox-staging',
    storageBucket: 'gearbox-staging.firebasestorage.app',
    messagingSenderId: '844943875890',
    appId: '1:844943875890:web:1bb8fa02a10e732fdb012b',
    measurementId: 'G-1ZDRMP9QLF',
  },
  prod: {
    apiKey: 'AIzaSyBvbH_lqniGgK81V4RLEYIb66WHRl6gZ5I',
    // When mytrainforge.com cuts over to gearbox-prod (today it points
    // at gearbox-staging), this authDomain takes effect. Keep it as the
    // custom domain so the cutover is a DNS change + nothing else.
    // Requires mytrainforge.com to be in this project's Authorized
    // domains list before traffic flips.
    authDomain: 'mytrainforge.com',
    projectId: 'gearbox-prod-47fd7',
    storageBucket: 'gearbox-prod-47fd7.firebasestorage.app',
    messagingSenderId: '612851086087',
    appId: '1:612851086087:web:8e9e8a793455133f840ba2',
    measurementId: 'G-B02B3J9X90',
  },
};

// Env selection lives in src/lib/firebaseEnv.js (pure + unit tested).
// CUTOVER NOTE: when mytrainforge.com DNS flips to gearbox-prod, the deploy
// build must run with VITE_FIREBASE_ENV=prod. Hostname sniffing cannot tell
// the difference because the hostname stays mytrainforge.com on both sides.
export const env = pickFirebaseEnv(
  import.meta.env?.VITE_FIREBASE_ENV,
  typeof window !== 'undefined' ? window.location.hostname : '',
);
export const firebaseConfig = configs[env];

const app = initializeApp(firebaseConfig);
// Explicit persistence so the session survives an app restart inside the iOS
// WKWebView (Capacitor). The array is tried in order: IndexedDB first, falling
// back to localStorage when IndexedDB is unavailable (jsdom in tests, private
// browsing). We use email/password only, so no popupRedirectResolver is needed.
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence],
});
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'us-east5');
export function storageRef(path) { return ref(storage, path); }
export { uploadBytes, getDownloadURL, deleteObject };
export default app;
